<div class="route-header" *ngIf="detail">
    <div class="route-title">
        <shared-copyclipboard [value]="detail.routeKey">{{ detail.routeKey }}</shared-copyclipboard>
    </div>

    <div class="header-body">
        <div class="driver-photo">
            <img *ngIf="detail.driverPhoto" [src]="detail.driverPhoto" alt="driver" />
            <mat-icon *ngIf="!detail.driverPhoto">person</mat-icon>
        </div>

        <div class="driver-info">
            <span class="carrier-trademark">{{ detail.carrierTrademark }}</span>
            <span class="carrier-name">{{ detail.carrierName }}</span>
            <span class="driver-name">{{ detail.driverName }}</span>
            <span class="driver-phone">{{ detail.driverPhone }}</span>
        </div>

        <div class="right-block">
            <div class="plates">
                <div class="plate">
                    <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.PLATEA' | translateH}}</div>
                    <span *ngIf="detail.plateA">{{ detail.plateA }}</span>
                    <span class="invisible" *ngIf="!detail.plateA">{{'ACTIVESLOTS.NOPLATEA' | translateH}}</span>
                </div>
                <div class="plate">
                    <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.PLATEB' | translateH}}</div>
                    <span *ngIf="detail.plateB">{{ detail.plateB }}</span>
                    <span class="invisible" *ngIf="!detail.plateB">{{'ACTIVESLOTS.NOPLATEB' | translateH}}</span>
                </div>
                <div class="plate">
                    <div class="toplabel">{{'ROUTEPAGE.ITEM.EDIT.PLATEC' | translateH}}</div>
                    <span *ngIf="detail.plateC">{{ detail.plateC }}</span>
                    <span class="invisible" *ngIf="!detail.plateC">{{'ACTIVESLOTS.NOPLATEC' | translateH}}</span>
                </div>
            </div>
            <div class="action-buttons">
                <a mat-icon-button [href]="phoneHref" *ngIf="phoneHref">
                    <mat-icon>call</mat-icon>
                </a>
                <a mat-icon-button [href]="smsHref" *ngIf="smsHref">
                    <mat-icon>message</mat-icon>
                </a>
            </div>
        </div>
    </div>
</div>